import React from "react";
import { Skeleton } from "@shadcn-in-nx/ui/skeleton";

function ChatPageSkeletonMobile() {
    return (
        <div className="bg-white flex flex-col h-screen">
            {/* Header */}
            <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-200 flex-shrink-0">
                <Skeleton className="w-8 h-8 rounded-lg" />
                <Skeleton className="h-4 w-40 flex-1" />
            </div>

            {/* Chat messages skeleton */}
            <div className="flex-1 p-4 space-y-4 overflow-hidden">
                <div className="flex gap-3">
                    <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                    <div className="space-y-2 flex-1">
                        <Skeleton className="h-3 w-3/4" />
                        <Skeleton className="h-3 w-1/2" />
                    </div>
                </div>
                <div className="flex gap-3 justify-end">
                    <div className="space-y-2 max-w-[70%]">
                        <Skeleton className="h-3 w-full" />
                        <Skeleton className="h-3 w-2/3" />
                    </div>
                </div>
                <div className="flex gap-3">
                    <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                    <div className="space-y-2 flex-1">
                        <Skeleton className="h-3 w-5/6" />
                        <Skeleton className="h-3 w-3/5" />
                    </div>
                </div>
            </div>

            {/* Input skeleton */}
            <div className="p-4 border-t border-gray-100 flex-shrink-0">
                <Skeleton className="h-12 w-full rounded-xl" />
            </div>

            {/* Bottom nav skeleton */}
            <div className="border-t border-gray-200 px-4 py-3 flex-shrink-0">
                <Skeleton className="h-10 w-full rounded-lg" />
            </div>
        </div>
    );
}

export default React.memo(ChatPageSkeletonMobile);
